export default __webpack_public_path__ + "static/media/edumeet-pic1.62a1ea34.png";